module.exports = __webpack_public_path__ + "docs/Regulation-Best-Interest-Disclosure.pdf";